module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_function-to-string.js
// module id = ./node_modules/core-js/modules/_function-to-string.js
// module chunks = 53 54